module.exports = __webpack_public_path__ + "img/app.8c33592e.png";